import { console } from 'react-redux-app/lib/modules/core/utils';
import { handleOnEnterException } from 'react-redux-app/lib/modules/routing/utils';

import { INTERNAL_ERROR_URI } from 'react-redux-app/lib/modules/routing/constants';
import { maybeHandleCriticalError } from 'react-redux-app/lib/modules/api/utils';

import { CAMPAIGN_STATUS__ACTIVE } from '../../../campaign/constants';

import { actionLoadCampaignNamesRequest } from '../../../campaign/actions/campaigns';
import { getLoadCampaignNamesError } from '../../../campaign/selectors/campaignNames';


export default ({ getState, dispatch }) => (
  function loadCampaignNamesHandler(nextState, successCallback, errorCallback) {
    dispatch(
      actionLoadCampaignNamesRequest({ status: CAMPAIGN_STATUS__ACTIVE })
    ).then(
      () => {
        if (handleOnEnterException(getState(), errorCallback, INTERNAL_ERROR_URI)) {
          return;
        }

        const error = getLoadCampaignNamesError(getState());
        if (
          error
          && maybeHandleCriticalError(nextState.location, error.globalErrors, errorCallback)
        ) {
          return;
        }

        successCallback();
      }
    ).catch(error => {
      console.consoleError('loadCampaignNamesHandler failed', error);
      errorCallback(INTERNAL_ERROR_URI);
    });
  }
);
